export const DEFAULT_SITE_URL = "https://crypsey.com";

/**
 * Prefer an explicit env var, otherwise fall back to the current origin.
 * This runs in the browser (CRA) so `window` is expected at runtime.
 */
export function getSiteOrigin(): string {
  const fromEnv = process.env.REACT_APP_SITE_URL?.trim();
  if (fromEnv) return fromEnv.replace(/\/+$/, "");

  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin.replace(/\/+$/, "");
  }

  return DEFAULT_SITE_URL;
}

export function toAbsoluteUrl(pathOrUrl: string): string {
  const v = pathOrUrl?.trim();
  if (!v) return getSiteOrigin();
  if (/^https?:\/\//i.test(v)) return v;
  const path = v.startsWith("/") ? v : `/${v}`;
  return `${getSiteOrigin()}${path}`;
}

export function stripQueryAndHash(pathname: string): string {
  return pathname.split("?")[0].split("#")[0];
}

